var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlustracao404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 413,
    height: 461.362,
    viewBox: "0 0 413 461.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1359",
    "data-name": "Rectangle 1359",
    width: 413,
    height: 461.362,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1360",
    "data-name": "Rectangle 1360",
    width: 72.576,
    height: 30.744,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077",
    transform: "translate(-21516 6265.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076",
    transform: "translate(21516 -6265.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3073",
    "data-name": "Group 3073",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M431.3,758.678c0,15.2-32.554,27.51-72.706,27.51-38.881,0-70.63-11.548-72.608-26.069a9.253,9.253,0,0,1-.426-2.771V652.573a72.834,72.834,0,0,1,145.667,0V757.349c0,.026-.007.046-.007.073a10.119,10.119,0,0,1,.079,1.257",
    transform: "translate(-160.926 -326.711)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M356.158,785.641c-40.173,0-72.112-11.829-74.453-27.543a11.16,11.16,0,0,1-.465-3.181V650.141a74.718,74.718,0,0,1,149.436,0v104.8a11.991,11.991,0,0,1,.072,1.309c0,16.483-32.764,29.394-74.59,29.394m-.2-206.453a70.905,70.905,0,0,0-70.946,70.953V754.917a7.371,7.371,0,0,0,.34,2.208l.069.309c1.837,13.476,33.57,24.44,70.742,24.44,38.39,0,70.821-11.735,70.821-25.626a8.317,8.317,0,0,0-.064-1.026l-.014-.37.007-.05V650.141a70.964,70.964,0,0,0-70.954-70.953m74.7,176.006,0,.032c0-.01,0-.021,0-.032m-3.732-.515c0,.011,0,.021,0,.032Z",
    transform: "translate(-158.493 -324.278)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349",
    "data-name": "Rectangle 1349",
    width: 91.099,
    height: 64.847,
    transform: "translate(149.796 330.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M433.765,822.559H338.9V753.944h94.867Zm-91.1-3.768H430v-61.08H342.666Z",
    transform: "translate(-190.986 -424.886)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1350",
    "data-name": "Rectangle 1350",
    width: 11.79,
    height: 70.741,
    transform: "translate(15.243 107.899) rotate(-9.261)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M41.96,313.959,29.969,240.422l15.356-2.5,11.991,73.538Zm-7.666-70.425,10.779,66.1,7.918-1.291-10.779-66.1Z",
    transform: "translate(-16.889 -134.079)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1351",
    "data-name": "Rectangle 1351",
    width: 24.235,
    height: 38.646,
    transform: "matrix(0.987, -0.161, 0.161, 0.987, 18.49, 164.444)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M44.236,409.253,37.41,367.392l27.638-4.507,6.826,41.861Zm-2.5-38.748,5.614,34.423,20.2-3.294-5.614-34.423Z",
    transform: "translate(-21.082 -204.504)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1352",
    "data-name": "Rectangle 1352",
    width: 28.82,
    height: 72.051,
    transform: "matrix(0.987, -0.161, 0.161, 0.987, 32.722, 143.873)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    width: 11.79,
    height: 70.741,
    transform: "translate(297.75 61.832) rotate(-9.262)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M689.246,208.408l-11.991-73.537,15.355-2.5L704.6,205.9Zm-7.667-70.425,10.78,66.1,7.918-1.291-10.779-66.1Z",
    transform: "translate(-381.667 -74.596)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1354",
    "data-name": "Rectangle 1354",
    width: 24.235,
    height: 38.646,
    transform: "translate(300.351 118.482) rotate(-9.262)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M690.04,303.944l-6.825-41.861,27.638-4.507,6.826,41.861Zm-2.5-38.748,5.613,34.423,20.2-3.294L707.74,261.9Z",
    transform: "translate(-385.026 -145.157)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1355",
    "data-name": "Rectangle 1355",
    width: 28.82,
    height: 72.051,
    transform: "translate(275.795 104.236) rotate(-9.262)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    width: 68.776,
    height: 25.545,
    transform: "translate(125.405 61.066) rotate(-9.262)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M380.142,64.5c-.237-1.118-5.687-27.525,4.934-40.032a17.528,17.528,0,0,1,10.106-5.932c1.9-3.958,5.876-8.243,13.6-12.077a24.646,24.646,0,0,1,17.807-1.585q.849-.65,1.826-1.312l.179-.107c.217-.113,21.792-11.148,35.605,6.813l-2.987,2.3a21.516,21.516,0,0,0-19.85-8.759A32.534,32.534,0,0,0,430.891,6.53a21.8,21.8,0,0,1,2.372,1.364c4.131,2.749,6.37,6.335,6.144,9.837-.141,2.179-1.311,5.27-6.085,7.625-3.957,1.954-10.112-.363-12.667-4.762-1.188-2.045-2.844-6.807,2.48-12.607a20.975,20.975,0,0,0-12.682,1.85c-4.878,2.423-8.457,5.227-10.632,8.243.468,0,.934.009,1.41.031,5.16.239,15.04,7.237,16.053,13.979.339,2.255-.061,6.385-6.543,8.712-5.359,1.922-12.94-2.651-15.9-9.6a15.441,15.441,0,0,1-1.013-8.394,13.593,13.593,0,0,0-5.88,4.1c-9.436,11.111-4.175,36.555-4.121,36.811Zm17.7-42.561a11.011,11.011,0,0,0,.464,7.786c2.295,5.388,8.058,8.642,11.16,7.528,4.537-1.628,4.2-3.869,4.09-4.605-.71-4.725-8.785-10.6-12.5-10.775a22.922,22.922,0,0,0-3.212.066M427.378,9.108c-3.819,3.411-5.083,6.807-3.465,9.594,1.65,2.84,5.759,4.253,7.742,3.275,1.744-.86,3.853-2.338,3.991-4.488.133-2.06-1.58-4.533-4.471-6.458a18.905,18.905,0,0,0-3.8-1.922",
    transform: "translate(-213.324 -0.001)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M293.333,92.334a58.826,58.826,0,0,0-5.677-21.471c-7.09-14.669-19.228-23.673-36.077-26.763l.68-3.706c22.609,4.146,33.608,18.038,38.854,28.963A61.525,61.525,0,0,1,297.1,92.239Z",
    transform: "translate(-141.777 -22.764)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M419.077,601.359,301.359,621.6a72.842,72.842,0,0,1,117.718-20.24",
    transform: "translate(-169.831 -326.711)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M339.237,139.9l26.049,159.742a18.637,18.637,0,0,1-15.393,21.391L151.361,353.4A18.637,18.637,0,0,1,129.97,338.01L103.922,178.267a18.637,18.637,0,0,1,15.393-21.391L317.846,124.5A18.637,18.637,0,0,1,339.237,139.9",
    transform: "translate(-58.427 -70.025)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M145.888,353.1a20.534,20.534,0,0,1-20.209-17.222L99.63,176.139a20.543,20.543,0,0,1,16.95-23.554l198.531-32.374a20.545,20.545,0,0,1,23.554,16.949L364.713,296.9a20.543,20.543,0,0,1-16.95,23.554L149.233,352.831a20.794,20.794,0,0,1-3.345.272M318.423,123.71a16.791,16.791,0,0,0-2.706.22L117.186,156.3a16.771,16.771,0,0,0-13.837,19.229L129.4,335.275a16.754,16.754,0,0,0,19.229,13.837l198.531-32.374a16.77,16.77,0,0,0,13.837-19.229L334.946,137.767a16.779,16.779,0,0,0-16.523-14.057",
    transform: "translate(-55.995 -67.593)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M121.933,198.016,153.98,394.543l-2.618.427a18.638,18.638,0,0,1-21.391-15.393L103.922,219.834a18.637,18.637,0,0,1,15.393-21.391Z",
    transform: "translate(-58.427 -111.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M145.888,394.308a20.532,20.532,0,0,1-20.209-17.221L99.63,217.345a20.543,20.543,0,0,1,16.95-23.554l4.478-.73L153.71,393.306l-4.478.73a20.747,20.747,0,0,1-3.345.272M117.944,197.386l-.759.123a16.77,16.77,0,0,0-13.837,19.229L129.4,376.48a16.753,16.753,0,0,0,19.229,13.837l.759-.124Z",
    transform: "translate(-55.995 -108.799)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M612.395,139.9l26.049,159.742a18.637,18.637,0,0,1-15.393,21.391l-2.618.427L588.385,124.929,591,124.5A18.637,18.637,0,0,1,612.395,139.9",
    transform: "translate(-331.584 -70.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M616.084,321.187,583.431,120.941l4.478-.73a20.541,20.541,0,0,1,23.554,16.949L637.511,296.9a20.543,20.543,0,0,1-16.95,23.554ZM587.756,124.054,619.2,316.861l.759-.123a16.77,16.77,0,0,0,13.837-19.229L607.744,137.767a16.767,16.767,0,0,0-19.229-13.837Z",
    transform: "translate(-328.793 -67.593)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M128.4,244.367a4.913,4.913,0,1,1-5.639-4.058,4.913,4.913,0,0,1,5.639,4.058",
    transform: "translate(-66.86 -135.39)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M618.68,164.419a4.913,4.913,0,1,1-5.639-4.058,4.913,4.913,0,0,1,5.639,4.058",
    transform: "translate(-343.156 -90.335)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M185.887,596.893a4.913,4.913,0,1,1-5.639-4.058,4.913,4.913,0,0,1,5.639,4.058",
    transform: "translate(-99.256 -334.056)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M676.165,516.945a4.913,4.913,0,1,1-5.639-4.058,4.913,4.913,0,0,1,5.639,4.058",
    transform: "translate(-375.552 -289.002)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M248.361,278.673l-11.816-8.249-14.317,20.507-20.091-14.9-8.583,11.576,20.421,15.142L199.424,323.6l11.816,8.249,14.317-20.508,20.09,14.9,8.583-11.576-20.421-15.142Z",
    transform: "translate(-109.078 -152.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M208.3,331.082l-14.9-10.406,14.583-20.889-20.463-15.174,10.827-14.6,20.047,14.865,14.285-20.463,14.9,10.406L233,295.708l20.463,15.174-10.827,14.6-20.047-14.865Zm-9.659-11.339,8.726,6.092,14.348-20.553,20.134,14.93,6.339-8.548-20.379-15.11,14.522-20.8-8.726-6.092L219.26,290.212l-20.134-14.93-6.339,8.548,20.379,15.111Z",
    transform: "translate(-105.675 -149.01)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M516.4,271.908l-20.421-15.142,14.553-20.845-11.816-8.249L484.4,248.179l-20.09-14.9-8.583,11.576L476.149,260,461.6,280.846l11.816,8.249,14.317-20.508,20.09,14.9Z",
    transform: "translate(-256.826 -128.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M470.476,288.331l-14.905-10.406,14.584-20.889-20.464-15.174,10.827-14.6,20.047,14.865,14.285-20.463,14.905,10.406-14.582,20.889,20.463,15.174-10.827,14.6-20.046-14.865Zm-9.659-11.339,8.727,6.092,14.348-20.553,20.133,14.929,6.339-8.548L489.986,253.8,504.509,233l-8.727-6.092-14.347,20.552L461.3,232.531l-6.339,8.549L475.34,256.19Z",
    transform: "translate(-253.423 -124.918)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1357",
    "data-name": "Rectangle 1357",
    width: 157.202,
    height: 5.24,
    transform: "matrix(0.987, -0.161, 0.161, 0.987, 106.099, 223.489)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M649.017,93.462a19,19,0,1,0,15.69-21.8,18.995,18.995,0,0,0-15.69,21.8",
    transform: "translate(-365.612 -40.242)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M473.549,490.209l-2.864-17.562,39.866-6.5,2.864,17.562a20.2,20.2,0,1,1-39.866,6.5",
    transform: "translate(-265.255 -262.697)",
    fill: "#f7966b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M490.643,506.251A22.092,22.092,0,0,1,468.9,487.72L465.731,468.3l43.585-7.108,3.167,19.422a22.08,22.08,0,0,1-18.239,25.346,22.366,22.366,0,0,1-3.6.293m-18.026-19.138a18.312,18.312,0,1,0,36.147-5.894l-2.561-15.7-36.147,5.894Z",
    transform: "translate(-262.463 -259.904)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M37.746,193.14a19,19,0,1,1-21.8-15.69,19,19,0,0,1,21.8,15.69",
    transform: "translate(0 -99.861)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1358",
    "data-name": "Rectangle 1358",
    width: 3.93,
    height: 21.777,
    transform: "matrix(0.986, -0.164, 0.164, 0.986, 222.931, 207.103)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M759.738,937.484a23.988,23.988,0,0,1-11.8-2.824,31.8,31.8,0,0,1-5.015-3.618c-4.725,2.9-10.144,4.645-15.114,4.082a19.493,19.493,0,0,1-8.289-2.758,22.412,22.412,0,0,1-23.99.3c-10.8,4.58-19.6,4.9-26.164.956-9.651-5.8-10.632-18.546-10.67-19.085l3.759-.261c.009.113.905,11.358,8.872,16.129,5.141,3.078,12.19,2.909,20.985-.5a17.324,17.324,0,0,1-4.033-17.781c1.67-4.642,5.177-7.562,8.928-7.449,7.134.221,9.068,4.657,9.584,7.281,1.239,6.291-2.806,14.6-7.5,18.533a18.824,18.824,0,0,0,12.652,1.15,18.448,18.448,0,0,0,4.507-1.823,16.319,16.319,0,0,1-3.721-6.876c-1.9-6.956.173-15.6,4.524-18.886,2.369-1.787,7.419-1.883,10.877.837,2.219,1.746,5.381,5.972,1.621,14.656a30.24,30.24,0,0,1-7.019,10.3,16.555,16.555,0,0,0,5.5,1.529c3.806.432,8.125-.906,12.017-3.157-4.458-5.655-4.093-11.606-1.63-16.025,2.924-5.247,8.39-8.11,11.93-6.256,4.359,2.283,6.014,6.346,4.54,11.146-1.241,4.042-4.625,8.344-8.984,11.744a30.442,30.442,0,0,0,3.75,2.587c4.024,2.383,11.744,3.376,18.713.669A19.806,19.806,0,0,0,780.6,918.826l3.6,1.1A23.461,23.461,0,0,1,769.931,935.6a28.206,28.206,0,0,1-10.192,1.885M696.989,908.44c-2.029,0-4.1,1.978-5.17,4.96a13.721,13.721,0,0,0,4.19,14.852c3.976-2.549,8.1-10.393,7.08-15.567-.541-2.747-2.5-4.135-6-4.243l-.1,0m24.779-1.9a4.074,4.074,0,0,0-2.251.524c-2.769,2.089-4.752,9.046-3.158,14.886a12.547,12.547,0,0,0,3.206,5.663,25.953,25.953,0,0,0,6.723-9.561c1.446-3.338,2.533-7.816-.493-10.2a6.592,6.592,0,0,0-4.028-1.314m26.355,2.6c-1.591,0-4.448,1.728-6.214,4.9-1.2,2.156-2.871,6.895,1.462,12.124,3.94-2.958,7.056-6.729,8.114-10.175.943-3.07.064-5.262-2.685-6.7a1.453,1.453,0,0,0-.677-.143",
    transform: "translate(-371.206 -508.757)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M119.81,885.472v19.073c0,6.32,10.247,11.443,22.887,11.443s22.887-5.123,22.887-11.443V885.472Z",
    transform: "translate(-67.519 -499.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M140.265,915.44c-13.89,0-24.771-5.854-24.771-13.327V881.156h49.541v20.956c0,7.473-10.88,13.327-24.771,13.327m-21-30.516v17.188c0,4.521,8.626,9.56,21,9.56s21-5.038,21-9.56V884.924Z",
    transform: "translate(-65.087 -496.576)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M165,867.107c0,6.873-11.144,12.445-24.89,12.445s-24.89-5.572-24.89-12.445,11.144-12.445,24.89-12.445S165,860.234,165,867.107",
    transform: "translate(-64.932 -481.645)",
    fill: "#0f329d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M168.954,873.281c0,3.124-5.065,5.657-11.314,5.657s-11.314-2.533-11.314-5.657,5.065-5.657,11.314-5.657,11.314,2.533,11.314,5.657",
    transform: "translate(-82.462 -488.95)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3080",
    "data-name": "Group 3080",
    transform: "translate(21675 -5918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M12.894,8.736h.085V18.985H6.3ZM12.138.5,0,18.985v5.292H12.979V30.24h6.048V24.277h3.821V18.985H19.027V.5Z",
    fill: "#ef4123"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3079",
    "data-name": "Group 3079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3078",
    "data-name": "Group 3078",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M25.242,15.372A30.723,30.723,0,0,1,25.726,10,15.734,15.734,0,0,1,27.447,5.04a10.272,10.272,0,0,1,3.381-3.633A9.771,9.771,0,0,1,36.289,0a9.768,9.768,0,0,1,5.459,1.407A10.272,10.272,0,0,1,45.129,5.04,15.786,15.786,0,0,1,46.852,10a30.222,30.222,0,0,1,0,10.752A15.769,15.769,0,0,1,45.129,25.7a10.255,10.255,0,0,1-3.381,3.633,9.76,9.76,0,0,1-5.459,1.407,9.762,9.762,0,0,1-5.461-1.407A10.255,10.255,0,0,1,27.447,25.7a15.716,15.716,0,0,1-1.721-4.956,30.706,30.706,0,0,1-.484-5.376m6.3,0q0,1.176.1,2.814a13.7,13.7,0,0,0,.568,3.15A6.675,6.675,0,0,0,33.621,23.9a3.4,3.4,0,0,0,2.668,1.05,3.417,3.417,0,0,0,2.646-1.05,6.544,6.544,0,0,0,1.427-2.562,13.808,13.808,0,0,0,.568-3.15q.1-1.638.1-2.814t-.1-2.813a13.806,13.806,0,0,0-.568-3.151,6.54,6.54,0,0,0-1.427-2.561A3.417,3.417,0,0,0,36.289,5.8a3.4,3.4,0,0,0-2.668,1.051,6.671,6.671,0,0,0-1.406,2.561,13.7,13.7,0,0,0-.568,3.151q-.1,1.636-.1,2.813",
    fill: "#ef4123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M62.706,24.276H49.728V18.984L61.866.5h6.888v18.48h3.822v5.292H68.754V30.24H62.706Zm0-15.54h-.084L56.028,18.984h6.678Z",
    fill: "#ef4123"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracao404);
export default __webpack_public_path__ + "static/media/ilustracao-404.767ae16b2c563cfd3c4d19ccd8c3cc79.svg";
export { ForwardRef as ReactComponent };